/**
 * DemoBanner
 *
 * A subtle fixed banner shown when the current user is a demo account.
 * Communicates that actions are simulated and provides a CTA to sign up.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function DemoBanner() {
  const { isDemoAccount } = useAuth();

  if (!isDemoAccount) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-amber-600/95 backdrop-blur-sm text-white text-sm py-2 px-4 flex items-center justify-center gap-3">
      <span className="font-medium">
        Demo environment — actions are simulated
      </span>
      <span className="text-amber-200">|</span>
      <Link
        to="/signup"
        className="font-semibold underline underline-offset-2 hover:text-amber-100 transition-colors"
      >
        Sign up for free
      </Link>
    </div>
  );
}
